import React, {useRef, useState} from 'react';
import userService from "../../../../../../../services/web/user-service.js";
import ResetRetryCountdown from "../../../../../../../components/reset-retry-countdown/reset-retry-countdown.js";
import AlertMessages from "../../../../../../../components/messages/alert-message.js";
import projectUtils from "../../../../../../../utils/project-utils.js";
import {Modal} from "../../../../../../../components/modal/modal.jsx";
import Button from "../../../../../../../components/button/button.jsx";
import {FaCircleExclamation} from "react-icons/fa6";
import {FaEnvelope} from "react-icons/fa";
import {getAssetPath} from "../../../../../../../utils/get-asset-path.js";
import HandleHashInput from "../../../../../../../components/handle-hash/input.js";
import HandleHashPaste from "../../../../../../../components/handle-hash/paste.js";

let timerRunning = false;
let remainingSeconds = 30;

const DevicesPrincipalValidate = ({open, onClose, device, setDevices}) => {
    const resendBtn = useRef();
    const resendCode = useRef();
    const timerEl = useRef();
    const timer = useRef();
    const hashRef = useRef([]);

    const [errorMessage, setErrorMessage] = useState(undefined);

    const startPhoneValidate = () => {
        setErrorMessage(undefined);

        const formData = new FormData();
        formData.append("device_id", device.id);

        userService.setMainStart(formData)
            .then(() => ResetRetryCountdown(resendBtn, resendCode, timerEl, timerRunning, timer, remainingSeconds, startPhoneValidate))
            .catch((error) => {
                onClose(false);

                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                setTimeout(() => projectUtils.swalErrorMessage("", errMessage, "Ok"), 100);
            });
    }

    const setMainPhone = () => {
        const hash = [...hashRef.current].map(el => el.value).join("");

        const formData = new FormData();
        formData.append("hash", hash);

        userService.setMainPersist(formData)
            .then(() => {
                setDevices(prev => prev.map(p => ({...p, main: p.id === device.id})));

                onClose();
            })
            .catch(error => {
                console.error(error);
                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível prosseguir.";
                setErrorMessage(errMessage)
            });
    }

    return (
        <Modal isCloseClick={false} open={open} setOpen={() => onClose()} centered size="md" backdrop="static" keyboard={false} className = "w-4/12"
               onShow={startPhoneValidate} title={<img src={getAssetPath("/img/logo.svg")} alt="Sentry" title="Sentry" className={"w-[100px]"}/>}>

            <Modal.Body className="mb-2">
                <div className="text-center">
                    <div className="text-center mb-4">
                        Insira o código de 6 dígitos enviado para:
                        <br/>
                        <b>{projectUtils.formatPhone(device?.phone)}</b>
                    </div>

                    <div className="py-0">
                        <div className="flex justify-center items-center mb-4">
                            <div className="flex gap-2">
                                {[...Array(6)].map((_, index) => (
                                    <input
                                        key={index}
                                        className="bg-white bg-none border border-[#e5e6e7] text-inherit block px-3 py-1.5 uppercase w-[35px] h-[35px] rounded-[3px]"
                                        type="text"
                                        maxLength="1"
                                        required
                                        autoFocus={index === 0}
                                        ref={(el) => hashRef.current[index] = el}
                                        onInput={(e) => HandleHashInput(e, index, hashRef)}
                                        onPaste={(e) => HandleHashPaste(e, hashRef)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {
                        !!errorMessage &&
                        <div className="items-center justify-center text-[13px] font-[400] flex gap-1">
                            <FaCircleExclamation color={"#f27474"} className={"mb-[1px]"}/> {errorMessage}
                        </div>
                    }

                    <span id="resend-btn" className="flex gap-1 justify-center items-center mt-3 text-[#063A6C]" ref={resendBtn}>
                        <FaEnvelope color={"#063A6C"}/>
                        Não recebeu o código?
                        <span id="resend-code" className={"cursor-pointer underline"} ref={resendCode}>Reenviar</span>
                        <span ref={timerEl}></span>
                    </span>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className={"w-100 flex justify-end"}>
                    <Button onClick={setMainPhone}>
                        Concluir
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default DevicesPrincipalValidate;